export default function pluralize(
  num: number,
  singular: string,
  plural: string = `${singular}s`
) {
  return `${num} ${num === 1 ? singular : plural}`;
}
